import logo from './logo.svg';
import './App.css';
import PremiumWebsite from './Components/mainComponent';


function App() {
  return (
    <div>
      <PremiumWebsite/>
    </div>
  );
}

export default App;
